import React from 'react';
import { IBestDataset } from '../../../../../types/analytics';
import { IEnrichedMetadata } from '../../../../../types/metadata';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import TidalLevel from '../Plot/TidalLevel/TidalLevel';
import { TabKey } from '../../../../../utils/common';
import { IAdvancedAnalyticsApiPayload } from '../../../../../types/chart';

interface TidalLevelBoxProps {
  activePlotAnalytics: string | null;
  enrichedMetadata: IEnrichedMetadata[];
  previewDatasetId: string;
  coordinates: number[];
  datasets: IBestDataset[];
  dateRange: any;
  updating: boolean;
  onUpdate: (payload: IAdvancedAnalyticsApiPayload) => void;
  tidalLevelValueImage: string;
  tidalValueLinks: string[];
  error: string;
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (update: Partial<IAnalytcisUserInput>) => void;
  onDatasetChange: (value: string) => void;
  point?: MarkerItem;
  onChangeActiveKey: (item: any, key?: TabKey) => void;
  pointOption: { label: string; value: string }[];
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  isOfflineDataset: boolean
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
}

const TidalLevelBox: React.FC<TidalLevelBoxProps> = ({
  activePlotAnalytics,
  enrichedMetadata,
  previewDatasetId,
  coordinates,
  datasets,
  dateRange,
  updating,
  onUpdate,
  tidalLevelValueImage,
  tidalValueLinks,
  error,
  pointName,
  userInput,
  updateUserInput,
  onDatasetChange,
  point,
  onChangeActiveKey,
  pointOption,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  isOfflineDataset
}) => {
  if (activePlotAnalytics !== 'Tidal Levels') {
    return null;
  }

  return (
    <TidalLevel
      previewDatasetId={previewDatasetId}
      coordinates={coordinates}
      datasets={datasets}
      dateRange={dateRange}
      enrichedMetadata={enrichedMetadata}
      updating={updating}
      onUpdate={onUpdate}
      tidalLevelValueImage={tidalLevelValueImage}
      tidalValueLinks={tidalValueLinks}
      error={error}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      onDatasetChange={onDatasetChange}
      point={point}
      onChangeActiveKey={onChangeActiveKey}
      pointOption={pointOption}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      isOfflineDataset={isOfflineDataset}

    />
  );
};

export default TidalLevelBox;
